import { render, staticRenderFns } from "./DoctorPaymentReceipt.vue?vue&type=template&id=a861316a&scoped=true"
import script from "./DoctorPaymentReceipt.vue?vue&type=script&lang=js"
export * from "./DoctorPaymentReceipt.vue?vue&type=script&lang=js"
import style0 from "./DoctorPaymentReceipt.vue?vue&type=style&index=0&id=a861316a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a861316a",
  null
  
)

export default component.exports